import Nullstack from 'nullstack';
export default function IconJumpRope({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-jump-rope",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6 14v-6a3 3 0 1 1 6 0v8a3 3 0 0 0 6 0v-6"
  }), "   ", Nullstack.element("rect", {
    x: "16",
    y: "3",
    width: "4",
    height: "7",
    rx: "2"
  }), "   ", Nullstack.element("rect", {
    x: "4",
    y: "14",
    width: "4",
    height: "7",
    rx: "2"
  }), " ");
}